import React from "react";
import Grid from "../layout/grid";
import SimpleCurrencyInput from "react-simple-currency";
import { convertIntegerToMoney } from "../../modules/helpers";

export default (props) => {
  let inputCol = props.colSize;
  let inputColClasses = `col-md-${inputCol} col-sm-${inputCol} col-xs-${inputCol}`;

  return (
    <div>
      <div
        className={`${inputColClasses} input-value ${
          props.disabled ? "disabled" : ""
        }`}
        style={{ display: "flex" }}
      >
        <button
          type="button"
          className={`btn btn-primary decrease-button`}
          style={{ marginRight: "5px" }}
          onClick={() => props.onIncrement(-1 * props.increment)}
          disabled={props.disabled}
        >
          - {convertIntegerToMoney(props.increment)}
        </button>
        <SimpleCurrencyInput
          id={props.id}
          precision={2}
          className="form-control"
          separator=","
          delimiter="."
          value={props.value}
          onInputChange={props.onChange}
          onInputBlur={props.onBlur}
        />
        <button
          type="button"
          className={`btn btn-primary increase-button`}
          onClick={() => props.onIncrement(1 * props.increment)}
          disabled={props.disabled}
        >
          + {convertIntegerToMoney(props.increment)}
        </button>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/common/form/buttonAndMoney.jsx